export default "/images/d8ec3c2e9b01c06dc891159052c0f5ba.avif";